export default "__VITE_ASSET__5d2cdc59__"